import { Actions } from 'mailup-web-components'
import { modalSharedListsCallback } from 'Pages/SourcesList/recoil/callbacks/callbacks'
import { modalDeleteState } from 'Pages/SourcesList/recoil/state/modals'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useSetRecoilState } from 'recoil'

const ActionsMenu = ({ info }) => {
  const intl = useIntl()
  const history = useHistory()
  const setModalDeleteState = useSetRecoilState(modalDeleteState)
  const modalSharedLists = useRecoilCallback(modalSharedListsCallback, [])

  const handleEdit = () => {
    history.push(`/automation/source/${info.SourceType}/${info.Id}`)
  }

  const handleViewContents = () => {
    history.push(
      `/automation/source/viewContents/${info.SourceType}/${info.Id}`
    )
  }

  const handleDeleteChange = () => {
    setModalDeleteState((prev) => ({
      ...prev,
      show: true,
      idRow: info.Id,
      sourceName: info.SourceName
    }))
  }

  const menuActions = []
  menuActions.push({
    label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
    separator: false,
    onClick: handleEdit
  })
  menuActions.push({
    label: intl.formatMessage({ id: 'Load.ContentsSources.ViewContents' }),
    separator: false,
    onClick: handleViewContents
  })
  menuActions.push({
    label: intl.formatMessage({ id: 'Load.ContentsSouces.ShareAction' }),
    separator: false,
    onClick: () => {
      modalSharedLists(info.Id)
    }
  })
  menuActions.push({
    label: intl.formatMessage({ id: 'Load.MailupCommon.Delete' }),
    separator: true,
    onClick: () => {
      handleDeleteChange()
    }
  })

  return <Actions items={menuActions} />
}

export default ActionsMenu

ActionsMenu.propTypes = {
  info: PropTypes.object
}
